import { useEffect, useRef } from "react";
import { Animated } from "react-native";

const CategoryChipSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;
  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 800,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  }, []);
  return (
    <Animated.View
      style={{ opacity }}
      className="h-9 w-24 rounded-full bg-ash-3"
    />
  );
};
export default CategoryChipSkeleton;
